import * as React from 'react';

interface NotHitsModel {
    searchTerm: string
}

const NoHits: React.FC<NotHitsModel> = (props) => {
    
    return (
        <div className="ofg-bodytext">
            {props.searchTerm && props.searchTerm.length > 0 && props.searchTerm !== "initial_search" && (
                <>
                    <h2>Beklager, vi fant ingen treff på "{props.searchTerm}"</h2>
                    <p>Her er noen tips du kan prøve:</p>
                    <ul>
                        <li>Sjekk skrivemåten - kanskje det har lurt seg inn en liten skrivefeil der?</li>
                        <li><a href="/sok/" title="Søkeside">Utforsk våre deilige oppskrifter</a> og se om noe frister der</li>
                        <li><a href="/" title="Gå til forsiden">Gå til forsiden</a> og prøv en annen vei</li>
                    </ul>
                </>
            )}


            {props.searchTerm && props.searchTerm.length > 0 && props.searchTerm === "initial_search" && (
                <>
                    <h2>Beklager, vi fant ingen treff</h2>
                    <p>Her er noen tips du kan prøve:</p>
                    <ul>
                        <li>Endre filtrene</li>
                        <li><a href="/sok/" title="Søkeside">Utforsk våre deilige oppskrifter</a> og se om noe frister der</li>
                        <li><a href="/" title="Gå til forsiden">Gå til forsiden</a> og prøv en annen vei</li>
                    </ul>
                </>
            )}



        </div>
    );
};

export default NoHits;